import context, { SystemConstants } from '@truckdown/components-systems';
import { defineComponent, ref, Ref, onMounted, onUnmounted, computed } from 'vue';
interface IProps {
    section: string;
}

interface IData {
    completedStep: Ref<number>;
}

const getData = function () {
    return {
        completedStep: ref<number>(1)
    } as IData;
}

const getComputed = function (props: IProps, data: IData) {
    return {
        currentStep: computed(() => {
            if (props.section == 'favorites') {
                return 2;
            };
            if (props.section == 'vendors') {
                return 3;
            };
            if (props.section == 'setup') {
                return 4;
            };
            return 1;
        }),
        progressPercent: computed(() => {
            return data.completedStep.value * 25;
        })
    };
}

const setCompletedStep = function (data: IData) {
    const setting = context.settings['fleet_onboarding'];
    
    if (setting && setting == 'team') {
        data.completedStep.value = 1;
    }
    else if (setting && setting == 'favorites') {
        data.completedStep.value = 2;
    }
    else if (setting && setting == 'vendors') {
        data.completedStep.value = 3;
    }
    else if (setting && setting == 'complete') {
        data.completedStep.value = 4;
    }
    else {
        data.completedStep.value = 0;
    }
}

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },
    name: "fleet-setup-progress-tracker",
    emits: [],
    components: {
    },
    setup: function (props: any, ctx: any) {
        const data = getData();
        const computed = getComputed(props, data);

        const refreshContext = function () {
            setCompletedStep(data);
        }

        onMounted(() => {
            context.events.on(SystemConstants.Events.RefreshOnboardingProgress, refreshContext);
            setCompletedStep(data);
        })

        onUnmounted(() => {
            context.events.off(SystemConstants.Events.RefreshOnboardingProgress, refreshContext);
        });

        return {
            ...data,
            ...computed
        };
    }
});